// Paper Chapel storefront interactions v1.1. Publishes to Shopify, not directly to GA4.
(() => {
  if(window.__pcAnalytics || /^\/(account|checkouts?|orders)(\/|$)/.test(location.pathname))return;
  window.__pcAnalytics=true;
  // Shopify pixel permissions and the pixel consent gate control external delivery.
  function publish(action,parameters={}){
    if(!window.Shopify?.analytics?.publish)return false;
    window.Shopify.analytics.publish('paperchapel:interaction',{action,...parameters});return true;
  }
  // Count foreground, focused time after analytics consent, not time in a hidden tab.
  const consentAllowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  const active=()=>document.visibilityState==='visible' && document.hasFocus() && consentAllowed();
  let lastTick=performance.now(), wasActive=active(), activeMs=0;
  function tick(flush=false){
    const now=performance.now();
    if(wasActive && consentAllowed())activeMs+=Math.min(60000,Math.max(0,now-lastTick));
    lastTick=now;wasActive=active();
    if(!consentAllowed()){activeMs=0;return;}
    if(activeMs>=15000 || (flush && activeMs>=1)){
      const ms=Math.floor(Math.min(60000,activeMs));
      if(publish('page_active_time',{active_time_ms:ms}))activeMs-=ms;
    }
  }
  if(!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures==='function'){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{lastTick=performance.now();wasActive=active();});
  }
  setInterval(()=>tick(),5000);
  document.addEventListener('visibilitychange',()=>tick(true));
  document.addEventListener('visitorConsentCollected',()=>{activeMs=0;lastTick=performance.now();wasActive=active();});
  window.addEventListener('focus',()=>tick());
  window.addEventListener('blur',()=>tick(true));
  window.addEventListener('pagehide',()=>tick(true));
  document.addEventListener('submit',e=>{
    if(e.target.matches?.('form[action*="/cart/add"]'))publish('cart_attempt',{element_id:'add_to_cart'});
  },true);
  const reached=new Set();let queued=false;
  function scroll(){
    const height=document.documentElement.scrollHeight;
    if(height<=window.innerHeight)return;
    const depth=100*(window.scrollY+window.innerHeight)/height;
    for(const n of [25,50,75,90])if(depth>=n&&!reached.has(n)&&publish('scroll_depth',{percent_scrolled:n}))reached.add(n);
  }
  window.addEventListener('scroll',()=>{if(!queued){queued=true;setTimeout(()=>{queued=false;scroll();},200);}},{passive:true});
  document.addEventListener('click',e=>{
    const el=e.target.closest?.('a,button,summary');if(!el)return;
    const section=el.closest('[id^="shopify-section-"]')?.id || '';
    if(el.closest('media-gallery,product-modal'))publish('gallery_view',{element_id:el.id || el.getAttribute('name') || 'gallery_control',section_id:section});
    if(el.matches('[data-bpd-size-trigger]'))publish('details_open',{element_id:'size_options',section_id:section});
    if(el.tagName==='A' && el.closest('header,nav,footer')){
      try{const u=new URL(el.href);if(u.origin===window.location.origin)publish('navigation_click',{link_path:u.pathname,section_id:section});}catch{}
    }
  });
  document.addEventListener('toggle',e=>{if(e.target.tagName==='DETAILS'&&e.target.open)publish('details_open',{element_id:e.target.id || 'product_details',section_id:e.target.closest('[id^="shopify-section-"]')?.id || ''});},true);
  // Use the confirmed variant after Dawn finishes fetching the selected option.
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange)subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{const v=data?.variant;if(v)publish('size_select',{item_id:String(v.id),item_variant:String(v.public_title || v.title || '').slice(0,100)});});
  if(typeof IntersectionObserver!=='undefined'){
    const seen=new Set();
    const observer=new IntersectionObserver(entries=>{for(const entry of entries){const id=entry.target.id;if(entry.isIntersecting&&!seen.has(id)&&publish('section_view',{section_id:id})){seen.add(id);observer.unobserve(entry.target);}}},{threshold:0.2});
    document.querySelectorAll('main [id^="shopify-section-"]').forEach(el=>observer.observe(el));
  }
  // Dawn exposes a sanitized cart-error signal; do not transmit raw error text.
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartError)subscribe(PUB_SUB_EVENTS.cartError,()=>publish('cart_error',{element_id:'add_to_cart'}));
})();
